import * as pdfjs from "pdfjs-dist"
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url"

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl

export const PDF_PRINT_SECTION_STYLES = `
  .bl-pdf-print-page {
    width: 4in;
    height: 6in;
    page-break-after: always;
    break-after: page;
    overflow: hidden;
    padding: 0;
    margin: 0;
  }
  .bl-pdf-print-page:last-child { page-break-after: auto; break-after: auto; }
  .bl-pdf-print-img {
    width: 4in;
    height: 6in;
    display: block;
    object-fit: fill;
  }
`

/** Render PDF bytes as 4×6 print sections for combined HTML print jobs. */
export async function renderProcessingReceiptPdfForPrint(pdfBytes) {
    const loadingTask = pdfjs.getDocument({ data: pdfBytes.slice() })
    const pdf = await loadingTask.promise
    const sections = []

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum)
        const viewport = page.getViewport({ scale: 2 })
        const canvas = document.createElement("canvas")
        canvas.width = viewport.width
        canvas.height = viewport.height
        const ctx = canvas.getContext("2d")
        if (!ctx) {
            continue
        }

        await page.render({ canvasContext: ctx, viewport, canvas }).promise
        const dataUrl = canvas.toDataURL("image/png")
        sections.push(
            `<section class="bl-pdf-print-page"><img src="${dataUrl}" alt="" class="bl-pdf-print-img" /></section>`
        )
    }

    return sections.join("")
}
